// extracted by mini-css-extract-plugin
module.exports = {"button":"PointComponent_button__3pN1-"};